import { useQuery } from '@tanstack/react-query';
import { useLayoutHeaderContext } from '../../../../../modules/LayoutHeaderContext';
import { useMemo } from 'react';
import CookieManager from '../../../../utils/cookieManager';
import { ApiResponse, axiosInstance } from '@myrealtrip/fetch';

const fetchPlaceholder = (userId?: number) => {
  return axiosInstance.get<ApiResponse<string[]>>(
    `/search/main/v2/placeholder?agent=WEB&${
      userId ? `userId=${userId}` : ''
    }&pid=${CookieManager.get('log_pid')}`
  );
};

export default function useGetPlaceholder() {
  const { user } = useLayoutHeaderContext();
  const { data, isLoading } = useQuery({
    queryKey: ['fetchPlaceholder'],
    queryFn: () => fetchPlaceholder(user?.id),
    select: (response) => response.data.data,
  });

  const placeholders = useMemo(() => data || [], [data]);

  const placeholder = useMemo(() => {
    if (isLoading) return '';
    return placeholders.length > 0
      ? placeholders[Math.floor(Math.random() * placeholders.length)]
      : '도시나 상품을 검색해보세요';
  }, [isLoading, placeholders]);

  return { placeholder };
}
